export const ReportsPermissions = {

  ActivitiesReport: {
    permissionsId: '7626439e-0152-4434-5247-08d9918483b8',
    permissionsName: ' Activities Report',
    componentsId: null,
    components: null
  },
  DailyLeadReportSpecificDateOnly: {
    permissionsId: '9ae0c825-af64-4b41-5248-08d9918483b8',
    permissionsName: 'Daily Lead Report Specific Date Only',
    componentsId: null,
    components: null
  },
  ActivitiesLeadReportByLeadId: {
    permissionsId: '351d5fb6-5c1d-4ad1-5249-08d9918483b8',
    permissionsName: 'Activities Lead Report By Lead Id',
    componentsId: null,
    components: null
  },
  LeadsReport: {
    permissionsId: 'ceed1bc7-8e48-4455-524a-08d9918483b8',
    permissionsName: 'Leads Report',
    componentsId: null,
    components: null
  },
  ClosedLeadsReport: {
    permissionsId: '1426d550-ffb7-461d-524b-08d9918483b8',
    permissionsName: 'Closed Leads Report',
    componentsId: null,
    components: null
  },
  ContactsReport: {
    permissionsId: '6327f801-bd6b-42dd-524c-08d9918483b8',
    permissionsName: 'Contacts Report',
    componentsId: null,
    components: null
  },
  ContactsWithoutLeadsReport: {
    permissionsId: '53b98d7a-ac51-4eaa-524d-08d9918483b8',
    permissionsName: 'Contacts Without Leads Report',
    componentsId: null,
    components: null
  },
  ContactsWithEmailsReport: {
    permissionsId: 'ce0f3520-4ea0-46d2-524e-08d9918483b8',
    permissionsName: 'Contacts With Emails Report',
    componentsId: null,
    components: null
  },
  ContactByMediaTypeReport: {
    permissionsId: '657838ec-e9c9-4ca1-524f-08d9918483b8',
    permissionsName: 'Contact By Media Type Report',
    componentsId: null,
    components: null
  },
  BuyerLeadReportWithLastActivity: {
    permissionsId: 'fac40302-250d-40e1-5250-08d9918483b8',
    permissionsName: 'Buyer Lead Report With Last Activity',
    componentsId: null,
    components: null
  },
  TransactingContactsPersonalInformationReport: {
    permissionsId: '2120c74c-b898-44c2-5251-08d9918483b8',
    permissionsName: 'Transacting Contacts Personal Information Report',
    componentsId: null,
    components: null
  },
  LeadActivitiesReport: {
    permissionsId: '2bec30ca-0e9e-4e1e-5252-08d9918483b8',
    permissionsName: 'Lead Activities Report',
    componentsId: null,
    components: null
  },
  ViewingReportLeasingAgents: {
    permissionsId: '22a26d17-ad06-4776-5253-08d9918483b8',
    permissionsName: 'Viewing Report Leasing Agents',
    componentsId: null,
    components: null
  },
  OpenLeadsAgentWiseReport: {
    permissionsId: 'd09ac0ac-764e-42ab-a1e2-08d991ff5166',
    permissionsName: 'Open Leads Agent Wise Report',
    componentsId: null,
    components: null
  },
  BulkOwnersReport: {
    permissionsId: '830008f4-c6d1-4677-a1e3-08d991ff5166',
    permissionsName: 'Bulk Owners Report',
    componentsId: null,
    components: null
  },
  GetAllReports: {
    permissionsId: 'ef79e0e6-2fa3-4a1e-a1e4-08d991ff5166',
    permissionsName: 'Get All Reports',
    componentsId: null,
    components: null
  },
  ExportExcel: {
    permissionsId: 'bbe16e73-8f9d-480a-a1e5-08d991ff5166',
    permissionsName: 'Export Excel',
    componentsId: null,
    components: null
  }

};
